import _extends from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _assertThisInitialized from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _defineProperty from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { Component } from 'react';
import GenericTouchable, { TOUCHABLE_STATE } from './GenericTouchable';
import { StyleSheet, View } from 'react-native';
import PropTypes from 'prop-types';
/**
 * TouchableHighlight follows RN's implementation
 */

var TouchableHighlight =
/*#__PURE__*/
function (_Component) {
  _inherits(TouchableHighlight, _Component);

  function TouchableHighlight(props) {
    var _this;

    _classCallCheck(this, TouchableHighlight);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(TouchableHighlight).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "showUnderlay", function () {
      if (!_this.hasPressHandler()) {
        return;
      }

      _this.setState({
        extraChildStyle: {
          opacity: _this.props.activeOpacity
        },
        extraUnderlayStyle: {
          backgroundColor: _this.props.underlayColor
        }
      });

      _this.props.onShowUnderlay && _this.props.onShowUnderlay();
    });

    _defineProperty(_assertThisInitialized(_this), "hasPressHandler", function () {
      return _this.props.onPress || _this.props.onPressIn || _this.props.onPressOut || _this.props.onLongPress;
    });

    _defineProperty(_assertThisInitialized(_this), "hideUnderlay", function () {
      _this.setState({
        extraChildStyle: null,
        extraUnderlayStyle: null
      });

      _this.props.onHideUnderlay && _this.props.onHideUnderlay();
    });

    _defineProperty(_assertThisInitialized(_this), "onStateChange", function (from, to) {
      if (to === TOUCHABLE_STATE.BEGAN) {
        _this.showUnderlay();
      } else if (to === TOUCHABLE_STATE.UNDETERMINED || to === TOUCHABLE_STATE.MOVED_OUTSIDE) {
        _this.hideUnderlay();
      }
    });

    _this.state = {
      extraChildStyle: null,
      extraUnderlayStyle: null
    };
    return _this;
  } // Copied from RN


  _createClass(TouchableHighlight, [{
    key: "renderChildren",
    value: function renderChildren() {
      if (!this.props.children) {
        return React.createElement(View, null);
      }

      var child = React.Children.only(this.props.children);
      return React.cloneElement(child, {
        style: StyleSheet.compose(child.props.style, this.state.extraChildStyle)
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          _this$props$style = _this$props.style,
          style = _this$props$style === void 0 ? {} : _this$props$style,
          rest = _objectWithoutProperties(_this$props, ["style"]);

      var extraUnderlayStyle = this.state.extraUnderlayStyle;
      return React.createElement(GenericTouchable, _extends({}, rest, {
        style: [style, extraUnderlayStyle],
        onStateChange: this.onStateChange
      }), this.renderChildren());
    }
  }]);

  return TouchableHighlight;
}(Component);

_defineProperty(TouchableHighlight, "defaultProps", _objectSpread({}, GenericTouchable.defaultProps, {
  activeOpacity: 0.85,
  delayPressOut: 100,
  underlayColor: 'black'
}));

_defineProperty(TouchableHighlight, "propTypes", _objectSpread({}, GenericTouchable.publicPropTypes, {
  activeOpacity: PropTypes.number,
  underlayColor: PropTypes.string,
  style: PropTypes.any,
  onShowUnderlay: PropTypes.func,
  onHideUnderlay: PropTypes.func
}));

export { TouchableHighlight as default };